import { Slide } from "@jelly/lesson";
import { task as task03 } from "../../../../../task/course-02/lesson-07/task-03";
const task: Slide = {
  titleHtml: `Sound A has a level of L = 40 dB SPL and loudness values of N = 2 sones and L<sub>N</sub> = 50</br>phons. If Sound B has double the loudness as Sound A, then which of the following</br>can be said about Sound B?`,
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
